var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#9747FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99827,
    cy: 7.99974,
    r: 6.93333,
    fill: "#F7F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.334 5L5.74957 7.34668H5.79579L7.21136 5H8.2456L6.40246 8L8.25715 11H7.21714L5.79579 8.68555H5.74957L4.32822 11H3.28821L5.17467 8L3.29976 5H4.334Z",
    fill: "#9747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13105 11V5H11.24C11.7003 5 12.0816 5.08496 12.384 5.25488C12.6863 5.4248 12.9126 5.65723 13.0629 5.95215C13.2131 6.24512 13.2882 6.5752 13.2882 6.94238C13.2882 7.31152 13.2121 7.64355 13.06 7.93848C12.9098 8.23145 12.6825 8.46387 12.3782 8.63574C12.0758 8.80566 11.6954 8.89063 11.2371 8.89063H9.78684V8.12305H11.1562C11.447 8.12305 11.6829 8.07227 11.864 7.9707C12.045 7.86719 12.1779 7.72656 12.2626 7.54883C12.3474 7.37109 12.3898 7.16895 12.3898 6.94238C12.3898 6.71582 12.3474 6.51465 12.2626 6.33887C12.1779 6.16309 12.044 6.02539 11.8611 5.92578C11.68 5.82617 11.4412 5.77637 11.1446 5.77637H10.0237V11H9.13105Z",
    fill: "#9747FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXp);
export default __webpack_public_path__ + "static/media/XP.87bab5b36af6b8715f97c032bba99461.svg";
export { ForwardRef as ReactComponent };